import React, { useState, useEffect, useContext, useRef } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {
  useParams,
  Link,
  useHistory,
  useLocation,
  Redirect,
} from "react-router-dom";
import axios from "axios";
import {
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
} from "@material-ui/core";
import { BsCreditCard } from "react-icons/bs";
import { FaPiggyBank } from "react-icons/fa";
import { BsExclamationCircle } from "react-icons/bs";
import { MdContentCopy } from "react-icons/md";
import { CoinContext } from "../../contexts/CoinContext";
import * as Sentry from "@sentry/react";
import { REACT_APP_PROD_URL } from "../../services/configs";
import useResizer from "../../services/useResizer";
import Icon from "../../fontIcons/icon";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import qs from "query-string";
import useSWR from "swr";
import fetcher from "../../api/swr_fetcher";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import upi from "../../assets/icons/upi.png";
import CancelIcon from "@material-ui/icons/Cancel";
import { AnimatePresence, motion } from "framer-motion";
import { useInterval } from "../../services/useInterval";
import QRCode from "./qrcode.min.js";
import { Accordion as MuiAccordion } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} {...props} />
))(({ theme }) => ({
  border: `none`,

  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

export default function UPIDepositRequest(props) {
  const { data, error: VPAError } = useSWR(`/v1/um/bankAccount`, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  const qrCodeRef = useRef();
  // let apiTimeout = setTimeout(pollTransaction, 2000);
  const FIVE_MINUTES_MS = 300000;
  const POLLING_TIMEOUT_MS = 10000;
  // 300000;
  const isMobile = useResizer();
  const classes = useStyles();
  let history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.trading.TOKEN);

  const [expanded, setExpanded] = useState(false);
  const [timerDone, setTimerDone] = useState(false);
  const transaction = useSelector(
    (state) => state.trading.UPI_TRANSACTION_DATA
  );
  const timerProps = {
    isPlaying: true,
    size: 120,
    strokeWidth: 6,
  };
  // var sampleQR = new window.QRCode("qrcode", {
  //   text: "upi://pay?pa=pstesting1@yesbank&pn=pstesting1&mc=7399&tr=upi_a8cc6d82e6CIXdnA42FZ57&tn=invoice3&am=5&mam=&cu=INR&refUrl=",
  //   width: 228,
  //   height: 228,
  //   colorDark: "#000000",
  //   colorLight: "#ffffff",
  //   correctLevel: window.QRCode.CorrectLevel.H,
  // });
  useEffect(() => {
    if (transaction.intentUrl) {
      new QRCode(qrCodeRef.current, {
        text: transaction.intentUrl,
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    }
  }, [transaction]);

  useInterval(async () => {
    if (!timerDone) {
      const options = {
        headers: { Authorization: "Bearer " + token },
      };
      try {
        let response = await axios.get(
          `${REACT_APP_PROD_URL}/v1/transfers/inr/${transaction.orderId}`,
          options
        );
        if (response.data.status === "SUCCESS") {
          nextStep("success");
        } else if (response.data.status === "FAILED") {
          nextStep("failed");
        }
      } catch (e) {}
    }
  }, POLLING_TIMEOUT_MS);

  function timerCompleted() {
    setTimerDone(true);
  }
  function nextStep(variant) {
    dispatch({ type: "SET_UPI_TRANSACTION_DATA", payload: {} });
    history.replace({
      pathname: "/inr/deposit/upi",
      state: { method: variant },
    });
  }
  function fmtMSS(inputSeconds) {
    const secs = parseInt(inputSeconds, 10);
    let minutes = Math.floor(secs / 60);
    let seconds = secs - minutes * 60;

    if (10 > minutes) {
      minutes = minutes + "M";
    }
    if (10 > seconds) {
      seconds = "0" + seconds;
    }

    // Return display.
    return minutes + ":" + seconds + "S";
  }
  console.log(
    transaction,
    "yo",
    Date.now() - transaction.createdAt,
    id !== transaction.orderId
  );
  if (
    (!Boolean(transaction) &&
      Date.now() - transaction.createdAt > FIVE_MINUTES_MS) ||
    id !== transaction.orderId
  ) {
    return <Redirect to="/inr/deposit/upi" />;
  } else
    return (
      <div className={classes.container}>
        <div>
          <h1 className="mb-3">Deposit INR</h1>
          <p className="font-light mb-5">
            <span
              className="underline cursor-pointer"
              onClick={() => {
                history.push("/inr/deposit/upi");
              }}
            >
              Wallet
            </span>{" "}
            {">"}
            <span style={{ color: "#3AC4AB" }}> Deposit INR</span>
          </p>
        </div>
        <motion.div
          animate={{ y: 0, opacity: 1 }}
          initial={{ y: 200, opacity: 0 }}
          transition={{
            type: "tween",
            stiffness: 100,
            duration: 0.5,
          }}
        >
          <div className="dark:bg-[#141828] bg-[#eee] px-5 py-4 flex justify-between">
            <h4>Deposit Status</h4>
            <CancelIcon
              onClick={() => nextStep("cancel")}
              className="text-pb-secondary-100 cursor-pointer hover:text-opacity-60 transition-all"
            ></CancelIcon>
          </div>{" "}
          <Divider></Divider>
          <div className="dark:bg-[#141828] bg-[#eee] px-5 py-5">
            {transaction.intentUrl && (
              <h4 className="mb-8 sm:block hidden">
                Scan the QR code with your UPI app Linked to the below Bank
                account.
              </h4>
            )}
            <div className="md:flex-row flex-col flex justify-between ">
              <div className="">
                <div className="flex md:flex-col justify-between  h-full items-start md:items-start flex-wrap">
                  <div>
                    {" "}
                    <div className="flex gap-x-2 gap-y-2">
                      <p className=" items-center">Requested Amount</p>
                      <h4 className="text-pb-primary-100 sm:mb-8 mb-4">
                        ₹{Number(transaction.amount).toFixed(2)}
                      </h4>
                    </div>
                    <h3 className="mb-3 ">Your Registered account</h3>
                    <div className="mb-5">
                      <div className="sm:max-w-[50%] whitespace-nowrap sm:mb-8">
                        <div className="">
                          <div
                            className={classes.flexContainer}
                            style={{ marginTop: "5px" }}
                          >
                            <div className="w-full flex items-center justify-between gap-x-4 gap-y-2">
                              <p className={`${classes.ptitle}`}>
                                Account Number
                              </p>
                              <strong>
                                <p className={classes.pvalue}>
                                  {data?.accountNumber}
                                </p>{" "}
                              </strong>
                            </div>{" "}
                          </div>
                          <div className={classes.flexContainer}>
                            <div
                              className="flex whitespace-nowrap items-center w-full justify-between  gap-x-4 gap-y-2"
                              style={{ marginTop: "5px" }}
                            >
                              <p className={`${classes.ptitle}`}>IFSC Code</p>
                              <strong>
                                <p className={classes.pvalue}>{data?.ifsc}</p>
                              </strong>
                            </div>
                          </div>
                        </div>
                      </div>

                      {transaction.intentUrl &&
                        (isMobile ? (
                          <Accordion
                            disableGutters
                            elevation={0}
                            classes={{ root: classes.root }}
                            expanded={expanded}
                            onChange={(event, isExpanded) => {
                              setExpanded(isExpanded);
                            }}
                          >
                            <AccordionSummary
                              expandIcon={
                                <ChevronRightIcon className="rotate-90 text-pb-primary-100" />
                              }
                              classes={{
                                root: classes.summaryRoot,
                                content: classes.content,
                              }}
                            >
                              <p className="text-pb-primary-100">
                                Show QR Code
                              </p>
                            </AccordionSummary>
                            <AccordionDetails>
                              <div className="-ml-3 text-center flex flex-col justify-center items-center">
                                <div className="mb-2 p-2 bg-white w-max rounded-lg overflow-hidden">
                                  <div id="qrcode" ref={qrCodeRef}></div>
                                </div>
                                <p>Scan this code with a UPI App</p>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        ) : (
                          <div className="sm:-ml-10 flex flex-col justify-center items-center">
                            <div className="mb-2 p-2 bg-white w-max rounded-lg overflow-hidden">
                              <div id="qrcode" ref={qrCodeRef}></div>
                            </div>
                            <p>Scan this code with a UPI App</p>
                          </div>
                        ))}
                    </div>
                  </div>{" "}
                </div>
              </div>
              <Divider className="mb-10"></Divider>

              <AnimatePresence>
                {!timerDone && (
                  <div
                    className={`flex  flex-col items-center justify-center  order-last mb-5 md:mb-0`}
                  >
                    <h3 className="mb-4">Make Payment within</h3>{" "}
                    <div className="overflow-hidden">
                      <motion.div
                        animate={{ y: 0, opacity: 1 }}
                        initial={{ y: 200, opacity: 0 }}
                        exit={{ y: 500, opacity: 0 }}
                        transition={{
                          type: "tween",
                          stiffness: 100,
                          duration: 0.2,
                        }}
                      >
                        <CountdownCircleTimer
                          {...timerProps}
                          isPlaying
                          initialRemainingTime={
                            FIVE_MINUTES_MS / 1000 -
                            Math.round(
                              (Date.now() - transaction.createdAt) / 1000
                            )
                          }
                          duration={FIVE_MINUTES_MS / 1000}
                          colors={[["#3AC4AB"]]}
                          trailColor={"rgba(159, 159, 159, 0.28)"}
                          onComplete={timerCompleted}
                        >
                          {({ dimension, time, remainingTime }) =>
                            `${fmtMSS(remainingTime)}`
                          }
                        </CountdownCircleTimer>
                      </motion.div>
                    </div>
                  </div>
                )}
              </AnimatePresence>
            </div>
            {!expanded && (
              <Button
                type="submit"
                variant="contained"
                disableElevation
                color="primary"
                className="sm:hidden mt-5 w-full md:w-auto"
                onClick={() => {
                  window.open(transaction.intentUrl, "_blank");
                }}
                style={{
                  // width: isMobile ? "100%" : "25%",
                  height: "35px",
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "6px",
                  whiteSpace: "nowrap",
                }}
              >
                Pay Via UPI APP
              </Button>
            )}
            <div className="overflow-hidden">
              <AnimatePresence>
                {timerDone && (
                  <motion.div
                    animate={{ y: 0, opacity: 1 }}
                    initial={{ y: 200, opacity: 0 }}
                    exit={{ y: 500, opacity: 0 }}
                    transition={{
                      type: "tween",
                      stiffness: 100,
                      duration: 0.2,
                    }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      disableElevation
                      color="primary"
                      className="mt-5 w-full md:w-auto"
                      onClick={() => nextStep("i-have-paid")}
                      style={{
                        // width: isMobile ? "100%" : "25%",
                        height: "35px",
                        color: "white",
                        fontWeight: "bold",
                        textTransform: "none",
                        borderRadius: "6px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      I have paid
                    </Button>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>{" "}
          <Divider></Divider>
          <div className={`${classes.gridContainer} pb-5 pt-3`}>
            <div className={classes.subContainer}>
              <div
                className={classes.flexContainer}
                style={{
                  borderBottomStyle: "solid",
                  paddingBottom: "5px",
                  marginBottom: "15px",
                  borderColor: "#3AC4AB",
                  borderWidth: "2px",
                }}
              >
                <BsExclamationCircle
                  style={{ fontSize: "20px", color: "#3AC4AB" }}
                />
                <p
                  style={{
                    color: "#3AC4AB",
                    fontWeight: "bold",
                    marginLeft: "15px",
                  }}
                >
                  Note
                </p>
              </div>
              <ol
                style={{
                  marginTop: "10px",
                  marginLeft: "20px",
                }}
              >
                <li>Please make the payment before the timer runs out.</li>
                <li>Please wait upto 30 seconds after making the payment.</li>
                <li>
                  Do not close the screen before the transaction is complete.
                </li>

                <li>
                  If you have made the payment, it will reflect in your wallet
                  in 10-15 minutes.
                </li>
              </ol>
            </div>
          </div>
        </motion.div>
      </div>
    );
}

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    padding: "0px",
    width: "170px",
    background: "transparent",
    border: "none !important",
  }),
  content: {
    background: "transparent",
    margin: "0px 0px",
    padding: "0px",
  },

  summaryRoot: { margin: "0px 0px", padding: "0px", minHeight: "0px" },
  container: {
    flexGrow: 1,
    [theme.breakpoints.up("lg")]: {
      width: "52%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },
  grow: {
    flexGrow: 1,
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.text,
    paddingLeft: "10px",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    paddingTop: "3px",
  },
  subContainer: {
    marginTop: "15px",
    marginLeft: "20px",
    paddingBottom: "15px",
    marginRight: "15px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  ptitle: {
    fontSize: "16px",
    // marginLeft: "35px",
  },
  pvalue: {
    fontWeight: "bold",
  },
  copyIcon: {
    fontSize: "20px",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));
